// @ts-expect-error
import { SANTA_MEMBERS_APP_ID } from '@wix/communities-forum-universal/dist/src/constants/appsConfig';
import { getApplicationConfig } from './communities-context-selectors';
export var isMemberAreaActive = function (state) {
    return getApplicationConfig(state, SANTA_MEMBERS_APP_ID).isInstalled;
};
//# sourceMappingURL=member-area-selectors.js.map